module.exports = __webpack_public_path__ + "static/media/6.39a0e31f.svg";